import { SImage } from './api/Image'

export type UserProfile = {
  id: string
  name: string
  description: string
  image?: SImage | null
  default: boolean
  canHaveSpecialty?: boolean
}

export enum ProfilesUser {
  doctor = 'Médecin',
  clinic = 'Clinique',
  localAuthority = 'Collectivité territoriale',
  student = 'Etudiant / Externe',
  intern = 'Interne',
  employee = 'Salarié',
}

export enum ProfilesUserId {
  doctor = '1',
  intern = '2',
  student = '3',
}
